import { shallowMount } from "@vue/test-utils";
import Celular from "@/views/Celular";
import store from "@/store";

describe("Celular component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Celular, { store });
  });

  it("Renders del component Celular", () => {
    expect(wrapper).toBeDefined();
  });
});
